module.exports = __webpack_public_path__ + "static/img/teaser2.bc488d3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/teaser2.png
// module id = drn3
// module chunks = 0